var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrescriptionBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52.33 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#263d50;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Online_recept"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.64,59.21h0A6.52,6.52,0,0,1,26.41,50l7.4-7.78,6.28-6.61a6.52,6.52,0,0,1,9.22-.23h0a6.51,6.51,0,0,1,.23,9.21L35.86,59A6.52,6.52,0,0,1,26.64,59.21Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 42.7,
    y1: 51.78,
    x2: 33.25,
    y2: 42.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "22.6 14.5 18.02 14.5 18.02 18.55 22.6 18.55 22.6 23.12 26.64 23.12 26.64 18.55 31.21 18.55 31.21 14.5 26.64 14.5 26.64 9.93 22.6 9.93 22.6 14.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.24,
    y1: 30.54,
    x2: 31.77,
    y2: 30.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.24,
    y1: 37.78,
    x2: 31.77,
    y2: 37.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.24,
    y1: 45.03,
    x2: 21.48,
    y2: 45.03
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "21.92 53.2 1 53.2 1 11.78 1 11.77 11.77 1.01 11.78 1 40.15 1 40.15 31.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1 11.77 1 11.78 11.78 11.78 11.78 1 11.77 1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescriptionBlack);
export default __webpack_public_path__ + "static/media/prescriptionBlack.074b9b55b3d15051160f831fcda74064.svg";
export { ForwardRef as ReactComponent };